import React from "react";
var __jsx = React.createElement;
import { t } from "i18next";
export var AppointmentData = function AppointmentData(_ref) {
  var appointment_type = _ref.appointment_type,
    practitioners = _ref.practitioners,
    service_category = _ref.service_category,
    location = _ref.location,
    reasonText = _ref.reasonText,
    service_type = _ref.service_type;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-5 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("appointment_type")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left"
  }, appointment_type || "NA")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("label.provider_optional_multiple")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left"
  }, practitioners || "NA")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("service_category")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left capitalize"
  }, service_category || "NA"))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-start justify-between gap-3 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("location")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left"
  }, location || "NA")), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("reason_for_exam")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left"
  }, reasonText)), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-md text-gray-600 dark:text-gray-400 text-left"
  }, t("service_type")), /*#__PURE__*/React.createElement("div", {
    className: "text-base font-medium text-gray-800 dark:text-gray-200 text-left"
  }, service_type || "NA"))));
};